import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ReelVideo, TrackingParameters } from '../reels-models';
import { MediaPictureService } from 'projects/common/services/media-picture.service';
import { VideoPlayerService } from 'projects/common/services/video-player.service';
import { LandingModelService } from 'projects/common/services/landingModel.service';
import { ScreenType } from 'projects/common/model/ScreenType';
import { UpaService, UpaTarget } from 'projects/common/services/upa.service';

@Component({
  selector: 'reel-item',
  template: `
    <span *ngIf="!viewMore; else viewMoreCard " class="reel-card-item -play-icon" [style]="{'background-image': 'url('+ transformedUrlBackground + ')'}" (click)="showReel()">
      <div class="reel-card-item-wrapper-title"></div>
      <h6 class="reel-card-item-title reel-card-item-title-elipsis eva-3-h6 -eva-3-tc-white">{{reelItem.title}}</h6>
    </span>

    <ng-template #viewMoreCard>
      <span *ngIf="viewMore" class="reel-card-item reel-card-item-view-more" (click)="showReel()">
        <div class="reel-card-item-wrapper-content">
            <div class="reel-card-item-icon-container">
              <i class="reel-card-item-icon eva-3-icon-play -eva-3-icon-lg"></i>
            </div>
        </div>
        <h6 class="reel-card-item-title-view-more reel-card-item-title-elipsis eva-3-h6 -eva-3-tc-white">{{"reels.viewMore" | translate}}</h6>
      </span>
    </ng-template>
  `,
  styleUrls: ['./reel-item.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReelItemComponent implements OnInit {
  private static IMAGE_SIZE = "130x180"

  @Input() reelItem: ReelVideo;
  @Input() url: string;
  @Input() trackingParams: TrackingParameters;
  @Input() viewMore: boolean = false;
  @Input() positionIndex: number;

  transformedUrl: string
  transformedUrlBackground: string
  screenType: ScreenType;

  constructor(public mediaPictureService: MediaPictureService, 
              public videoPlayerService: VideoPlayerService, 
              public landingModelService: LandingModelService,
              private upaService: UpaService) {}

  ngOnInit(): void {
    this.transformedUrl = this.getTransformedUrl();
    this.transformedUrlBackground = this.getBackgroundImage()!;
    this.screenType = this.landingModelService.getLandingModel().device.type;
  }

  getTransformedUrl(): string {
    return `${this.url}&selectedId=${this.reelItem.id}`;
  }

  getBackgroundImage() {
    return this.mediaPictureService.getMediaUrl(this.reelItem.image.srcMobile || this.reelItem.image.src, ReelItemComponent.IMAGE_SIZE);
  }

  showReel(): void {
    if(this.screenType === ScreenType.DESKTOP){
      this.videoPlayerService.show({
        moduleId: this.trackingParams.moduleId,
        moduleIndex: this.trackingParams.moduleIndex,
        uniqueId: this.trackingParams.uniqueId,
        positionIndex: this.positionIndex + 1
        },
        {
          id: this.reelItem.id,
          title: this.reelItem.title,
          labels: [],
          videos: this.reelItem.videos,
          image: this.reelItem.image,
          link: this.reelItem.link,
        });
    } else {
      this.upaService.trackClickTopic({
        moduleId: this.trackingParams.moduleId,
        moduleIndex: this.trackingParams.moduleIndex,
        uniqueId: this.trackingParams.uniqueId,
        positionIndex: this.positionIndex + 1,
        target: UpaTarget.REEL,
        label: this.trackingParams.labelsTracker.split("|")[this.positionIndex],
        href: this.getTransformedUrl()
      });
      window.location.href = this.getTransformedUrl();
    }

  }
}
